const leadershipTabs = document.querySelector('.js-leadership-tabs');

if (leadershipTabs) {
    const triggers = [...leadershipTabs.querySelectorAll('.js-leadership__trigger')];
    const slider = leadershipTabs.querySelector('.js-leadership-tabs__slider');

    const flkty = new window.Flickity(slider, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        on: {
            ready() {
                triggers[this.selectedIndex].classList.add('is-active');
            },
        },
    });

    triggers.forEach((trigger, triggerIndex) => {
        trigger.addEventListener('click', () => {
            flkty.select(triggerIndex, false, true);
        });
    });

    flkty.on('select', (index) => {
        triggers.forEach((t) => {
            t.classList.remove('is-active');
        });

        triggers[index].classList.add('is-active');
    });
}




// WEBPACK FOOTER //
// ./resources/assets/js/modules/leadershipTabs.js